import { SortDirection, SortState, TableRequest, TableRequestSearch } from '..';
import { Filter, FilterTag } from '../types/Filter';
import { handleAndEncodeQueryParameter } from './queryParams';

const buildFilter = (filter: Filter) => {
  switch (filter.comparer) {
    case 'in':
    case 'notin':
      if (filter.rightList == undefined) {
        console.log('Trying to use filterQuery where `rightList` is not set');
        return null;
      }

      return `${filter.left} in ('${filter.rightList?.join("', '")}') eq ${
        filter.comparer == 'in' ? 'true' : 'false'
      }`;
    default:
      if (filter.right == undefined) {
        console.log('Trying to use filterQuery where `right` is not set');
        return null;
      }

      return `${filter.left} ${filter.comparer} '${filter.right}'`;
  }
};

export const createODataFilterQuery = (
  tags?: FilterTag[],
  filters?: Filter[],
  search?: TableRequestSearch
) => {
  if (!tags) {
    tags = [];
  }

  if (!filters) {
    filters = [];
  }

  const searchQuery =
    search && search.searchValue
      ? '(' +
        search.columns
          .map(
            (column) =>
              `contains(tolower(${column}), tolower('${encodeURIComponent(
                search.searchValue ?? ''
              )}'))`
          )
          .join(' or ') +
        ')'
      : '';

  const filterQuery = [
    ...filters.map((x) => buildFilter(x)).filter((x) => x != null),
    ...tags.map(
      (tag) =>
        `Tags/Any (c:c/Key eq '${
          tag.key
        }' and c/Value eq '${handleAndEncodeQueryParameter(tag.value)}')`
    ),
  ];

  if (searchQuery) {
    filterQuery.push(searchQuery);
  }

  if (filterQuery.length > 0) {
    return `&$filter=${filterQuery.join(' and ')}`;
  } else {
    return '';
  }
};

const PAGE_SIZE_DEFAULT = 10;

export const createODataPaginationQuery = ({
  pageSize,
  pageIndex,
}: {
  pageSize?: number;
  pageIndex: number;
}) => {
  return `&$top=${pageSize}&$skip=${
    pageIndex * (pageSize || PAGE_SIZE_DEFAULT)
  }`;
};

export const createODataOrderQuery = (sortBy: SortState<any, any>[]) => {
  if (sortBy.length > 0) {
    const sortQuery = sortBy
      .map(
        (x) =>
          x.accessor +
          ' ' +
          (x.direction === SortDirection.Descending ? 'desc' : '')
      )
      .join(',');

    return `&$orderby=${sortQuery}`;
  } else {
    return '';
  }
};

const defaultSort = {
  name: '',
  selector: (c: any) => c.id,
  accessor: 'id',
  direction: SortDirection.Ascending,
};

export const createODataQuery = (
  tableRequest: TableRequest<any, any>,
  tags: FilterTag[],
  filters: Filter[]
) => {
  let url = createODataFilterQuery(tags, filters, tableRequest.search);
  url += createODataPaginationQuery(tableRequest);
  url += createODataOrderQuery([tableRequest.sortState ?? defaultSort]);

  return url;
};
